module.exports = __webpack_public_path__ + "img/PorkMexico.acb7fee4.png";